<title>Server Internal Error</title>
<div class="error-page">
    <div class="error-image">
        <img class="img-fluid" src="assets/images/illustration/error500.svg" alt="Error page" />
    </div>
    <div class="error-message">
        <img class="oops-img" src="assets/images/illustration/Oops.svg" alt="Error page" />
        <p>Notre site est actuellement en</p><p> maintenance.</p>
    </div>
</div>
